import { useEffect as o } from "react";
import { disposables as u } from '../utils/disposables.js';
import { useLatestValue as c } from './use-latest-value.js';
function m(s, n, l) {
  var i = c(function (t) {
    var e = t.getBoundingClientRect();
    e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
  });
  o(function () {
    if (!s) return;
    var t = n === null ? null : n instanceof HTMLElement ? n : n.current;
    if (!t) return;
    var e = u();
    if (typeof ResizeObserver != "undefined") {
      var r = new ResizeObserver(function () {
        return i.current(t);
      });
      r.observe(t), e.add(function () {
        return r.disconnect();
      });
    }
    if (typeof IntersectionObserver != "undefined") {
      var _r = new IntersectionObserver(function () {
        return i.current(t);
      });
      _r.observe(t), e.add(function () {
        return _r.disconnect();
      });
    }
    return function () {
      return e.dispose();
    };
  }, [n, i, s]);
}
export { m as useOnDisappear };